// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"editor_wrapper__MU61N","header":"editor_header__UBNKZ headline_headline__is2WG","paragraph":"editor_paragraph__1B1gM","list":"editor_list__mOxaW"};